module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"version":"version","code":"code","show_services":"Show services"},"ua":{"version":"версія","code":"код","show_services":"Показать сервисы"},"ru":{"version":"версия","code":"код","show_services":"Показати сервіси"}}')
  delete Component.options._Ctor
}
